/*
  Flowkeeper - Pomodoro timer for power users and teams
  Copyright (c) 2023 Constantine Kulak, Geoffrey Espagne

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation; either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/

import {AbstractDataContainer} from "./abstract_data_container";
import {Backlog} from "./backlog";
import {adminUser} from "./abstract_data_item";
import {Origin} from "./abstract_stragegy";
import {Connection} from "./connection";
const Cookies = require("js-cookie");

export class Root extends AbstractDataContainer<Root, Backlog> {
    
    public lastSeq: number;
    public user: string;

    // user/account related
    public username: string|undefined;
    public userAvatar: string|undefined;
    public isLoggedIn: boolean;
    public needConsent: boolean;

    // too many requests sent 
    public isTooManyRequests: boolean;

    // data errors and warnings
    public isDecryptError: boolean;

    public constructor(another?: Root, username?: string, avatar?: string) {
        if (another) {
            super(another);
            this.username = another.username;
            this.userAvatar = another.userAvatar;

            this.lastSeq = another.lastSeq;
            this.user = another.user;

            // user/account related
            this.isLoggedIn = another.isLoggedIn;
            this.needConsent = another.needConsent;

            // too many requests sent 
            this.isTooManyRequests = another.isTooManyRequests;

            this.isDecryptError = another.isDecryptError;
        } else {
            super(undefined, 'root', undefined, new Date());
            this.username = username;
            this.userAvatar = avatar ? avatar : '/default-avatar.png';

            this.lastSeq = 1;
            this.user = adminUser;

            // user/account related
            this.isLoggedIn = false;
            this.needConsent = false;

            // too many requests sent
            this.isTooManyRequests = false;

            this.isDecryptError = false;
        }
    }

    public reset() {
        this.username = '';
        this.userAvatar = '/default-avatar.png';
        this.lastSeq = 1;
        this.user = adminUser;
        this.isLoggedIn = false;
        this.needConsent = false;
        this.isTooManyRequests = false;
        this.isDecryptError = false;
        this.children = new Map();
    }

    public clone(): Root {
        return new Root(this);
    }
}

// Strategies

export function Error_(origin: Origin, data: Root, connection: Connection, seq: number, when: Date, who: string, ...params: string[]): void {
    let httpCode = params[0];
    let errorMessage = params[1];
    console.error('Received an error from the server', httpCode, errorMessage);
    if (errorMessage === 'User consent is required') {
        data.needConsent = true;
    } else if (errorMessage === 'Too many requests') {
        data.isTooManyRequests = true;
    } else if (errorMessage.startsWith('Invalid Google auth token')) {
        // if invalid token; clear Cookies to force re-auth
        Cookies.remove('fw-utoken');
        Cookies.remove('fw-uauthtype');
        Cookies.remove('fw-uavatar');
    } else if (errorMessage.startsWith('Wrong password for user')) {
        // if invalid basic login; clear Cookies to force re-auth
        Cookies.remove('fw-utoken');
        Cookies.remove('fw-uauthtype');
        Cookies.remove('fw-uname');
        Cookies.remove('fw-uavatar');
        connection.isLoginError = true;
    }
}
Error_.realName = 'Error'
